import {isEmpty} from "@Array/isEmpty";

/**
 * Checks if provided array is not empty
 */
export const isNotEmpty = (array: any[] | string): boolean => !isEmpty(array)